export default "__VITE_ASSET__Dz6Bu1ZC__"